module.exports = require('./register')().Promise



//////////////////
// WEBPACK FOOTER
// ./~/any-promise/index.js
// module id = er1F
// module chunks = 0